module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#newsletter-usage",
      toString: function () {
        return this.url;
      }
    }